import styled, { css } from 'styled-components';

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: 0;
  font-weight: 500;
  transition: all 0.3s ease;
  text-decoration: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.ring};
    outline-offset: 2px;
  }
`;

const mono = css`
  font-family: ${({ theme }) => theme.fonts.sans};
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 500;
`;

const sizes = {
  sm: css`
    min-height: 2.25rem;
    padding: 0 0.75rem;
    font-size: 0.875rem;
  `,
  default: css`
    min-height: 2.5rem;
    padding: 0 1rem;
    font-size: 0.875rem;
  `,
  lg: css`
    min-height: 3rem;
    padding: 0 2rem;
    font-size: 0.875rem;
  `,
  xl: css`
    min-height: 3.5rem;
    padding: 0 2.5rem;
    font-size: 0.875rem;
  `,
  icon: css`
    min-height: 2.5rem;
    width: 2.5rem;
    padding: 0;
    font-size: 0.875rem;
  `,
};

const variants = {
  luxe: css`
    ${mono}
    background: ${({ theme }) => theme.colors.noir};
    color: ${({ theme }) => theme.colors.cream};
    border: 1px solid ${({ theme }) => theme.colors.noir};
    &:hover {
      background: ${({ theme }) => theme.colors.noirSoft};
      border-color: ${({ theme }) => theme.colors.champagne};
    }
  `,
  gold: css`
    ${mono}
    background: ${({ theme }) => theme.colors.champagne};
    color: ${({ theme }) => theme.colors.noir};
    border: none;
    &:hover {
      background: ${({ theme }) => theme.colors.champagneLight};
    }
  `,
  outlineLuxe: css`
    ${mono}
    background: transparent;
    color: ${({ theme }) => theme.colors.noir};
    border: 1px solid ${({ theme }) => theme.colors.noir};
    &:hover {
      background: ${({ theme }) => theme.colors.noir};
      color: ${({ theme }) => theme.colors.cream};
    }
  `,
  outlineCream: css`
    ${mono}
    background: transparent;
    color: ${({ theme }) => theme.colors.cream};
    border: 1px solid ${({ theme }) => theme.colors.cream};
    &:hover {
      background: ${({ theme }) => theme.colors.cream};
      color: ${({ theme }) => theme.colors.noir};
    }
  `,
};

export const Button = styled.button.attrs((p) => ({
  type: p.as === undefined ? p.type ?? 'button' : undefined,
}))`
  ${base}
  ${({ $size = 'default' }) => sizes[$size] ?? sizes.default}
  ${({ $variant = 'luxe' }) => variants[$variant] ?? variants.luxe}
`;
